import { MenuItem } from "@mui/material";
import { catalogOptionLabel } from "./fptTrasladosUtils";

const emptyOption = (emptyLabel) => (
  <MenuItem key="" value="">
    <em>{emptyLabel}</em>
  </MenuItem>
);

export const mapCatalogToOptions = (options = []) =>
  (options || []).map((option) => ({
    value: option.id,
    label: catalogOptionLabel(option),
  }));

export function catalogSelectMenuItems(
  options,
  includesEmptyOption = true,
  emptyLabel = "Sin asignar",
) {
  const list = Array.isArray(options) ? options : [];
  return [
    ...(includesEmptyOption ? [emptyOption(emptyLabel)] : []),
    ...list.map((option) => {
      if (option.value == null || option.value === "") {
        return emptyOption(emptyLabel);
      }
      return (
        <MenuItem
          disabled={Boolean(option.disabled)}
          key={String(option.value)}
          value={option.value}>
          {option.label}
        </MenuItem>
      );
    }),
  ];
}
